module.exports = __webpack_public_path__ + "static/media/Primate-House5.e107378f.jpg";